import s from '../collegesItem.module.css'
import { useState } from "react";

import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import { usersAPI } from "@api";
import classNames from 'classnames'
import noPhoto from '../../../../../../images/noPhoto.svg'
import { InputFile } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath';

const ModalEditAva = ({userId, setActive, avatarPath, setAvatarPath, setStateUpdate = (obj) => {} }) => {
  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);
 
  const [file, setFile] = useState(avatarPath ?? false)

  const [bindFile] = useInputNew({
    name: "file",
    value: file,
    onChange: setFile,
    placeholder: "Выберите файл",
    accept: ".jpg, .jpeg, .png, .svg, .gif",
  });

  const save = () => {
    
    const data = new FormData()
    if (typeof file === 'object' && file !== null) {
        setLoading(true);
        data.append("avatar_path", file);

        usersAPI.updAvatar({ id: userId, data })
        .then(res => {
            const img = res?.data?.avatar_path
            if (img) {
                setAvatarPath(img)
                setStateUpdate(
                  {avatar_path: img}
                )
                addAlert({ text: 'Ава успешно обновлена'})
                setActive(false)
            }
        })
        .finally((res)=>{
            setLoading(false)
        })
    }
    else{
        addAlert({ title: 'Ошибка', text: 'Ава не выбрана или не изменена', type: 'error' })
    }
  }

  

//   const del = () => {
//     setAvatarPath(null)
//     setActive(false)
//   }

  return <div className="modal_departments">
    <h2 className="modal__title">Редактировать фото профиля</h2>
    <div className={s.body}>
        <div className={classNames('ava', s.ava)}><img src={file ? (typeof file === 'object' ? URL.createObjectURL(file) : getCorrectFilePath(file)) : noPhoto} alt='' /></div>
        <InputFile {...bindFile} style={{width: '100%'}} />
       
        <Button disabled={loading} onClick={save}>Сохранить</Button>
        {/* <Button style={{background: '#974646', color: 'var(--color-on-accent)'}} disabled={loading} onClick={del}>Удалить</Button> */}
    </div>
  </div>
}
export default ModalEditAva